var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.84,
    height: 18.329,
    viewBox: "0 0 21.84 18.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_chat_4335858",
    transform: "translate(-5 -9.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15700",
    "data-name": "Group 15700",
    transform: "translate(5 9.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13799",
    "data-name": "Path 13799",
    d: "M38.211,22.71h-1.8V27.4a2.988,2.988,0,0,1-2.983,2.987H28.25v.14a1.724,1.724,0,0,0,1.721,1.721h4.468l2.681,2.681a.44.44,0,0,0,.31.127.366.366,0,0,0,.166-.035.438.438,0,0,0,.271-.4V32.248h.349a1.724,1.724,0,0,0,1.721-1.721v-6.1A1.731,1.731,0,0,0,38.211,22.71Z",
    transform: "translate(-18.096 -16.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13800",
    "data-name": "Path 13800",
    d: "M20.333,9.01H7.114A2.115,2.115,0,0,0,5,11.124v8.56A2.115,2.115,0,0,0,7.114,21.8H7.7V25.02a.434.434,0,0,0,.266.4.475.475,0,0,0,.17.035.417.417,0,0,0,.306-.131L11.974,21.8h8.359a2.114,2.114,0,0,0,2.109-2.114v-8.56A2.114,2.114,0,0,0,20.333,9.01ZM9.31,16.788A1.384,1.384,0,1,1,10.695,15.4,1.389,1.389,0,0,1,9.31,16.788Zm4.411,0A1.384,1.384,0,1,1,15.11,15.4,1.385,1.385,0,0,1,13.721,16.788Zm4.411,0A1.384,1.384,0,1,1,19.521,15.4,1.385,1.385,0,0,1,18.132,16.788Z",
    transform: "translate(-5 -9.01)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewChat);
export default __webpack_public_path__ + "static/media/preview_chat.3bfb51f665993eb2b29f0096e1c53ced.svg";
export { ForwardRef as ReactComponent };